<template>
  <ConfigProvider :locale="getAntdLocale">
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts" setup>
  import { watch, ref, onBeforeUnmount, nextTick } from 'vue';
  import { ConfigProvider } from 'ant-design-vue';
  import { AppProvider } from '/@/components/Application';
  import { useTitle } from '/@/hooks/web/useTitle';
  import { useLocale } from '/@/locales/useLocale';
  // import { themeOverrides } from '/@/screen/styles/themes/naive-ui-theme-overrides';
  // support Multi-language
  const { getAntdLocale } = useLocale();
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn';
  dayjs.locale('zh-cn');
  useTitle();
  import { useRoute } from 'vue-router';
  import { emitter, useStompClient, WS_EVENTS } from '/@/utils/wx/tkSetupStomp';
  import { useEventInfoStore } from '/@/store/modules/eventInfo';
  import { useUserStore } from '/@/store/modules/user';
  import { isEmpty } from '/@/utils/is';
  const stompClient = useStompClient();
  const eventInfoStore = useEventInfoStore();
  const userStore = useUserStore();
  const subscribeFn = (id: any) => {
    if (id && stompClient) {
      stompClient.subscribe(`/topic/web.l4nbSxx4.eventInfos.${id}`, (resData) => {
        console.log('全局消息', resData);
        if (!isEmpty(resData)) {
          eventInfoStore.setEventInfo(resData);
        }
      });
    }
  };
  const route = useRoute();
  const previousRoute = ref<string>('');
  watch(
    route,
    async (val) => {
      const regionId = userStore.getUserInfo ? userStore.getUserInfo.regionId : undefined;
      if (
        (!previousRoute.value && val.path && val.path !== '/login') ||
        previousRoute.value === '/login'
      ) {
        await nextTick();
        subscribeFn(regionId);
      }
      previousRoute.value = val.path;
    },
    { immediate: true, flush: 'post' },
  );
  emitter.on(WS_EVENTS.RECONNECT, () => subscribeFn(userStore.getUserInfo.regionId));
  onBeforeUnmount(() => {
    emitter.off(WS_EVENTS.RECONNECT, () => {});
  });
</script>
